import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { ImportTemplateResData } from "./ImportTemplateResData";

const ENDPOINT = "/security/installation/template/import";

export class ImportTemplateCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: ImportTemplateReqData = null;

    constructor(payload: ImportTemplateReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<ImportTemplateResData> {
        let res = await this.executeCommand(this.payload);
        return new ImportTemplateResData(res);
    }
}

export class ImportTemplateReqData {
    installationNames: string[];
    templateId: number;

    constructor(installationNames: string[], templateId: number) {
        this.installationNames = installationNames;
        this.templateId = templateId;
    }
}
